// Smooth fade-in when product media changes
(function () {
  function addFade() {
    var mainImage = document.querySelector('.product__media-item img, .product__media img, .product-media img');
    if (!mainImage) return;

    // Add fading class
    mainImage.classList.add('is-fading');

    // After slight delay, remove to reveal fade-in
    setTimeout(function () {
      mainImage.classList.remove('is-fading');
    }, 50); // trigger fade
  }

  // Anytime a variant changes, fade the main image
  document.addEventListener('change', function (event) {
    if (event.target.name === 'Letter') {
      addFade();
    }
  });

  document.addEventListener('DOMContentLoaded', addFade);
})();
